module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/4/4-618415fc1e3b307013349aed692dabb0.jpg";